import { useSyncExternalStore } from "react";

/** True while the media query matches (e.g. "(min-width: 768px)"); re-renders on change. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    },
    () => window.matchMedia(query).matches,
    () => false
  );
}

/** Tailwind `md` and up — tablet / desktop. */
export function useIsDesktop(): boolean {
  return useMediaQuery("(min-width: 768px)");
}
